import React from 'react';

import DatePicker from 'app/common/ui/DatePicker';
import WeekDayPicker from './WeekDayPicker';
import WeekPicker from './WeekPicker';

import styles from './Datebar.scss';


type Props = {
  day: Object,
  onChangeDay: Function,
}

const Datebar = ({ day, onChangeDay }: Props) => (
  <div className={styles.main}>
    <WeekDayPicker day={day.clone()} />

    <div className={styles.right}>
      <WeekPicker day={day.clone()} />
      <DatePicker day={day.toDate()} onChangeDay={onChangeDay} className={styles.datePicker} />
    </div>
  </div>
);

export default Datebar;
